import { render, staticRenderFns } from "./GroupRegister.vue?vue&type=template&id=c23584a4&"
import script from "./GroupRegister.vue?vue&type=script&lang=ts&"
export * from "./GroupRegister.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports